import * as React from 'react'

function SvgIconAt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="at" aria-labelledby="t-at d-at">
        <title id="t-at">{'At'}</title>
        <desc id="d-at">{'At symbol'}</desc>
        <path d="M32 14.2c0 1.8-.3 3.5-.9 5.1-.6 1.5-1.4 2.7-2.5 3.6-1.1.8-2.3 1.3-3.699 1.3-1.101 0-2.101-.3-2.896-1s-1.3-1.5-1.396-2.601H20.4a5.82 5.82 0 01-2.3 2.601c-1 .6-2.2 1-3.5 1-2 0-3.6-.7-4.7-2s-1.7-3.1-1.7-5.4c0-2.6.8-4.8 2.4-6.4 1.6-1.7 3.6-2.5 6.2-2.5.9 0 1.9.1 3.101.2C21 8.3 22.1 8.5 23 8.8l-.5 9.1v.4c0 2.3.9 3.5 2.7 3.5 1.2 0 2.2-.7 3-2.1.8-1.4 1.1-3.2 1.1-5.4 0-2.3-.5-4.4-1.5-6.2-1-1.8-2.4-3.1-4.2-4.1-1.8-1-3.896-1.4-6.3-1.4-3 0-5.6.6-7.8 1.8-2.2 1.2-3.9 2.9-5 5.1-1.2 2.2-1.7 4.8-1.7 7.7 0 4 1.1 7 3.2 9.1 2.1 2.101 5.2 3.2 9.3 3.2 2.8 0 5.7-.6 8.7-1.7v2.6c-2.6 1.1-5.5 1.6-8.7 1.6-4.8 0-8.6-1.3-11.3-3.9-2.7-2.6-4-6.2-4-10.8 0-3.4.7-6.4 2.1-9 1.4-2.6 3.5-4.7 6.1-6.1C10.9.7 13.9 0 17.3 0c2.9 0 5.4.6 7.7 1.8 2.2 1.2 4 2.8 5.2 5C31.4 9 32 11.4 32 14.2zm-20.7 2.6c0 3.3 1.3 4.9 3.9 4.9 2.8 0 4.3-2 4.5-6.1l.3-5.1c-1-.3-2-.4-3.1-.4-1.7 0-3.104.6-4.104 1.7-.996 1.1-1.496 2.9-1.496 5z" />
      </g>
    </svg>
  )
}

export default SvgIconAt
